export const getGameId = (id) => parseInt(id.substring(2), 16);
